

const state = {
  parameters: {
    brandName: null,
    commodityOverride: null,
    // The roll actually loaded on the floor. A station with a different one
    // picks its size in the printer panel, which is remembered on that phone;
    // this is only what a device starts at before anyone chooses.
    labelWidth: 90,
    labelHeight: 50,
    // 1 = one label per page (drivers that accept 3x2in);
    // 3 = stack three stickers on a 4x6in page for drivers locked to
    // 4x6 media (Android's print service) — 4x6 feeds exactly 3 labels
    labelsPerPage: 1,
    // Landscape page maps directly onto the label media; enable
    // rotate only for drivers that misalign landscape pages
    rotate: false,
    left: 10,
    right: 10,
    // extra headroom so the header never prints on the label's top edge
    top: 20,
    bottom: 10,
    qrSize: 100,
    // Copies printed of each label. Factory default is 4 stickers per bundle;
    // remembered per device once changed (see DEVICE_CONFIG_FIELDS).
    copies: 4,
    fontSize: 11,
    headerFontSize: 12,
    footerFontSize: 8,
    optionalFields: []
  },
  loading: false
};

const mutations = {
  setParameters(state, params) {
    state.parameters = params;
  },
  setLoading(state, status) {
    state.loading = status;
  }
};

const actions = {
  updateParameters({commit, state}, params) {
    commit('setParameters', Object.assign({}, state.parameters, params));
  },
};

const getters = {
  parameters: state => {
    return state.parameters;
  },
  isLoading: state => {
    return state.loading;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
